import { useEffect } from "react";
import { useEnvironment, AccountEnvironment } from "@keycloak/keycloak-account-ui";

export const DeleteAccount = () => {
    const context = useEnvironment<AccountEnvironment>();
    const keycloak = context.keycloak;

    useEffect(() => {
        keycloak.login({ action: "delete_nihonchouzai_account" });
    }, []);

  return <div />;
};